import { createSelector } from 'reselect';

const selectReferrerDashboard = (state) => state.get('referrerDashboard');

export const makeSelectPatients = () =>
	createSelector(selectReferrerDashboard, (sub) =>
		sub ? sub.get('patients')?.toJS() : []
	);

export const makeSelectPatientsTotal = () =>
	createSelector(selectReferrerDashboard, (sub) =>
		sub ? sub.get('patientsTotal') : 0
	);

export const makeSelectPatientsLoading = () =>
	createSelector(selectReferrerDashboard, (sub) =>
		sub ? sub.get('patientsLoading') : false
	);

export const makeSelectPending = () =>
	createSelector(selectReferrerDashboard, (sub) =>
		sub ? sub.get('pending')?.toJS() : []
	);

export const makeSelectPendingLoading = () =>
	createSelector(selectReferrerDashboard, (sub) =>
		sub ? sub.get('pendingLoading') : false
	);
